import { useCallback } from "react";

const LAST_LOGIN_KEY = "waLastLogin";

type LastLogin = {
  timeStamp: string;
  activityLogCreated: boolean;
};

export const useLastLogin = () => {
  // Sets/Resets the last login info in the local storage
  const setLastLogin = useCallback((timeStamp: string) => {
    const lastLogin = JSON.stringify({ timeStamp, activityLogCreated: false });
    localStorage.setItem(LAST_LOGIN_KEY, lastLogin);
    return lastLogin;
  }, []);

  // Gets the last login info from the local storage
  const getLastLogin = useCallback(() => {
    const lastLogin =
      localStorage.getItem(LAST_LOGIN_KEY) ||
      setLastLogin(new Date().toISOString());
    try {
      return JSON.parse(lastLogin) as LastLogin;
    } catch {
      return { timeStamp: "", activityLogCreated: false };
    }
  }, [setLastLogin]);

  // Updates the last login info in the local storage
  const updateLastLogin = useCallback(
    (activityLogCreated: boolean) => {
      const lastLogin = getLastLogin();
      lastLogin.activityLogCreated = activityLogCreated;
      localStorage.setItem(LAST_LOGIN_KEY, JSON.stringify(lastLogin));
    },
    [getLastLogin],
  );

  return {
    setLastLogin,
    updateLastLogin,
    getLastLogin,
  };
};
